import { useEffect, useState } from "react";
import getUrl from "../utility/getUrl";
import { AuthenticationInfoType } from "../utility/types";
import DeploymentCard from "./DeploymentCard";
import { Deployment } from "./PublishProject/types";

import "./Deployments.scss";

interface IProps {
  auth: AuthenticationInfoType;
}

const Deployments = ({ auth }: IProps) => {
  const [deployments, setDeployments] = useState<Deployment[]>([]);
  const [status, setStatus] = useState<string>("");

  useEffect(() => {
    const getDeployments = async () => {
      try {
        setStatus("loading ...");
        const url = getUrl("deployment");
        const options = {
          headers: new Headers({
            Authorization: `Bearer ${auth.accessToken}`,
          }),
        };
        const response = await fetch(url, options);
        if (response.status === 200) {
          let result: Deployment[] = await response.json();
          setDeployments(result);
          console.log(result);
          setStatus("");
        } else {
          setStatus(`error: ${response.statusText}`);
        }
      } catch (exception: any) {
        console.error(exception);
        setStatus(`error: ${exception.message}`);
      }
    };
    getDeployments();
  }, [auth]);

  return (
    <div className="deployments">
      {status ? <div>{status}</div> : null}
      {deployments.map((d) => (
        <DeploymentCard deployment={d} />
      ))}
    </div>
  );
};

export default Deployments;
